import { Divider } from "@mui/material";

export const TooltipDivider = () => {
  return <Divider sx={{ my: "0.75rem" }} />;
};
